import { Button } from "./ui/button";
import { TtsArena } from "./TtsArena";
import { SttArena } from "./SttArena";
import type { TabKey } from "../lib/tab-registry";

export const SpeechEvaluation = ({ activeTab, allowedTabs, onTabChange }: {
  activeTab: "ttsarena" | "sttarena";
  allowedTabs: readonly TabKey[];
  onTabChange: (tab: TabKey) => void;
}) => (
  <div className="flex h-full min-h-0 flex-col gap-3 overflow-y-auto">
    <div className="flex shrink-0 gap-2" aria-label="Speech evaluation tools">
      {([['sttarena', 'STT Evaluation'], ['ttsarena', 'TTS Evaluation']] as const).filter(([id]) => allowedTabs.includes(id)).map(([id, label]) => (
        <Button key={id} variant={activeTab === id ? "default" : "outline"} onClick={() => onTabChange(id)}>{label}</Button>
      ))}
    </div>
    <div className="min-h-0 flex-1">{activeTab === "sttarena" ? <SttArena /> : <TtsArena />}</div>
  </div>
);
